import EntityTypeEnum from 'common/enums/entityTypeEnum'
import EntityInterface from 'common/types/entities/EntityInterface'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import { generateBaseEntity } from '../utils/generate-base-entity'

export function createOrderSummary(
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): EntityInterface {
  return {
    ...generateBaseEntity(EntityTypeEnum.OrderSummary, parentId, masterBlockId),
  }
}
